<template>
  <div>
    <b-breadcrumb :items="itemsBread"></b-breadcrumb>
    <div v-if="loading" class="text-center">
      <div class="text-center mb-3 justify-content-between">
        <b-spinner variant="primary"></b-spinner>
      </div>
    </div>
    <div v-else class="d-flex flex-column mx-2 mb-5">
      <h2 style="display: flex;">Edit this Poll</h2>
      <div class="rounded shadow p-3 border bg-white">
        <div class="d-flex flex-row my-3 flex-wrap">
          <div class="w-50 me-3">
            <label class="">Poll Question</label>
            <input v-model="editPollInfo.question" class="form-control" placeholder="Enter Question of this poll"
                   type="text"/>
          </div>
          <div class="d-flex flex-column me-3">
            <label class="footerLabels">Status</label>
            <select v-model="editPollInfo.active_yn" class="py-2 border border-secondary rounded px-2 ">
              <option value="Y">Active</option>
              <option value="N">Inactive</option>
            </select>
          </div>
          <div class="d-flex flex-column me-3">
            <label class="footerLabels">Immediate Result</label>
            <select v-model="editPollInfo.show_percentage_yn" class="py-2 border border-secondary rounded px-2 ">
              <option value="Y">Yes</option>
              <option value="N">No</option>
            </select>
          </div>
          <div class="d-flex flex-column">
            <label class="footerLabels">Show Result</label>
            <select v-model="editPollInfo.enable_yn" class="py-2 border border-secondary rounded px-2 ">
              <option value="Y">Show</option>
              <option value="N">Don't Show</option>
            </select>
          </div>
        </div>
        <label class="footerLabels mb-3">Options</label>
        <div v-for="(option,index) in editPollInfo.pollOptionsList" :key="option">
          <div class="d-flex flex-row mb-2">
            <input v-model="option.option_text" class="col-md-6 form-control me-3" placeholder="Enter Title of popup"
                   type="text"/>
            <select v-model="option.enable_yn" class="p-2 me-3 border border-secondary rounded">
              <option value="Y">Active</option>
              <option value="N">Inactive</option>
            </select>
            <button v-if="editPollInfo.pollOptionsList.length > 1"
                    class="btn btn-danger btn-sm me-2" @click="deleteOption(index)"><span
                class="fa-solid fa-trash" style="width: 20px"></span>
            </button>
            <button v-if="index === editPollInfo.pollOptionsList.length - 1"
                    class="btn btn-success btn-sm" @click="addNewOption"><span
                class="fa-solid fa-plus" style="width: 20px"></span>
            </button>
          </div>
        </div>
        <div class="d-flex flex-row mt-3">
          <div class="btn btn-primary" style="width: 100px;" type="button" @click="saveNewPoll">Save Poll
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {notify} from "@kyvg/vue3-notification";
import pollService from "@/services/poll.service";

export default {
  name: 'EditPoll',
  components: {},
  mounted() {
    const res = this.$route.params.pollId;
    this.fetchPollInfo(res);
  },
  data() {
    return {
      itemsBread: [
        {
          text: 'Home',
          to: '/dashboard'
        }, {
          text: 'Polls',
          to: '/poll/all'
        }, {
          text: 'Add',
          href: '#'
        },

      ],
      editPollInfo: {},
      loading: false,
      showModalText: false,
      showModalLogo: false,
      pollData: {
        question: "",
        active_yn: "N",
      },
      pollOptions: [],
      imageBasePath: null,
    }
  },
  methods: {
    async fetchPollInfo(poll_id) {
      try {
        this.loading = true;
        const response = await pollService.getSinglePollData(poll_id);
        this.loading = false;
        this.editPollInfo = response.data;
      } catch (e) {
        this.loading = false;
        console.log(e)
      }
    },
    addNewOption() {
      this.editPollInfo.pollOptionsList.push({
        option_text: "New Option",
        enable_yn: "Y",
      })
    },
    deleteOption(data) {
      this.editPollInfo.pollOptionsList.splice(data, 1);
    },
    validations() {
      if (this.editPollInfo.question == null || this.editPollInfo.question === "") {
        notify({
          type: "error",
          title: "Question can not be empty",
        });
        return false;
      }
      this.editPollInfo.pollOptionsList.forEach(option => {
        if (option.option_text == null || option.option_text === "") {
          notify({
            type: "error",
            title: "Option text can not be empty",
          });
          return false;
        }
      })
      return true;
    },

    async saveNewPoll() {
      try {
        if (!this.validations()) {
          return;
        }
        const requestBody = {
          poll_id: this.editPollInfo.poll_id,
          show_percentage_yn: this.editPollInfo.show_percentage_yn,
          question: this.editPollInfo.question,
          active_yn: this.editPollInfo.active_yn,
          enable_yn: this.editPollInfo.enable_yn,
          pollOptionsList: [],
        };
        this.editPollInfo.pollOptionsList.forEach(option => {
          requestBody.pollOptionsList.push(
              {
                option_id: option.option_id,
                option_text: option.option_text,
                enable_yn: option.enable_yn,
              }
          )
        });
        this.loading = true;
        const response = await pollService.editPollData(requestBody);
        this.loading = false;
        if (response.data) {
          if (response.data.status === true) {
            notify({
              type: "success",
              title: "Edit Poll",
              text: response.data.message,
            });
            this.$router.go(-1);
          } else {
            notify({
              type: "error",
              title: "Error",
              text: response.data.message,
            });
          }
        } else {
          notify({
            type: "error",
            title: "Error",
            text: "Save poll data failed",
          });
        }
      } catch (error) {
        this.loading = false;
        notify({
          type: "error",
          title: "Error",
          text: "Save poll data failed",
        });
      }
    }
  }
}
</script>

<style scoped>
.form-control {
  height: 35px;
  margin: 0px;
}
</style>